<template>
    <section class="home-container">
        <MasterPage title="饮食分析">
            <div slot="title-icon">
                <Icon type="ios-restaurant" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="100">
                    <Row>
                        <Col span="12">
                        <FormItem label="用户患者：">
                            <Select v-model="select.userId" filterable clearable placeholder="请选择">
                                <Option v-for="item in userAllList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="饮食时间：">
                            <DatePicker v-model="select.date" :clearable="true" type="date" placeholder="请选择时间" style="width:100%"></DatePicker>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe max-height="400" :loading="tableLoading" :columns="columnsInfo" :data="pcAnalyzeDietLogInfo"></Table>
            </div>
        </MasterPage>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                userAllList:[],
                pcAnalyzeDietLogInfo:[],
                columnsInfo:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.foodId != null) {
                                return h('span',params.row.nutritionTypeName+"("
                                    + params.row.nutritionTypeEngName + "-"+ params.row.nutritionForShort +")")
                            }
                        }
                    },
                    {
                        title: '摄入量',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.foodId != null) {
                                if (params.row.compare == 'down') {
                                    return h('span', {style: {color: '#ed4014'}}, params.row.sumGetValue + " " + params.row.nutritionUnit)
                                } else {
                                    return h('span', {style: {color: '#19be6b'}}, params.row.sumGetValue + " " + params.row.nutritionUnit)
                                }
                            }
                        }
                    },
                    {
                        title: '推荐量',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.foodId != null) {
                                return h('span', params.row.goalValue + " " + params.row.nutritionUnit)
                            }
                        }
                    },
                ],
                tableLoading:false,
                select:{
                    userId:'',
                    date:'',
                },
            }
        },
        created(){
            this.findAllUser()
        },
        methods:{
            fileBefore(file){
                if (file.type.substring(0,file.type.indexOf("/")).toLowerCase() != 'image' ) {
                    this.$Message.warning('只能上传图片文件');
                    return false
                }
                if (file.size > 1048576) {
                    this.$Message.warning('图片大小请勿超过1M');
                    return false
                }
                return true
            },
            fileSuccess(response){
                this.$Notice.success({title:'图片上传成功'});
                this.itemAdd.imageUrl = response.data.replace(/\\/g,"/")
            },
            fileSuccess_update(response){
                this.$Notice.success({title:'图片上传成功'});
                this.updateInfoItem.imageUrl = response.data.replace(/\\/g,"/")
            },
            fileError(error){
                this.$Notice.error({title:'图片上传失败',desc: error.message});
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                if (this.select.userId.length <= 0){
                    return this.$Message.warning('请选择用户患者');
                }
                if (this.select.date === undefined || this.select.date === null || this.select.date === ""){
                    return this.$Message.warning('请选择分析时间');
                }
                this.tableLoading= true
                this.pcAnalyzeDietLogInfo = []
                this.$Message.loading('正在加载中。。。')
                this.$http.post('dietLog/pcAnalyzeDietLog',{
                    useId:this.select.userId,
                    date:this.select.date+"",
                }).then(function (res) {
                    this.tableLoading= false
                    let msg = res.body
                    if (msg.success) {
                        for (let i = 0 ; i < msg.data.length ; i++){
                            let item = msg.data[i]
                            if (item.foodId !=null){
                                this.pcAnalyzeDietLogInfo.push(item)
                            }
                        }
                    }else {
                        this.$Notice.error({title:'医生列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading= false
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


